/* ============================================================
   FILE: assets/new-faq.js
   Accordion logic: clicking a question toggles + <-> -,
   and closes whichever other question was open.
   Called from sections/new-faq.liquid via window.initNewFaq(rootId)
   ============================================================ */

window.initNewFaq = function (rootId) {
  var root = document.getElementById(rootId);
  if (!root) return;

  // Shopify's richtext editor sometimes leaves an empty trailing
  // paragraph (e.g. <p><br></p>) which takes up line-height space
  // even with margin removed — strip those out so answers don't
  // have extra empty space at the bottom.
  root.querySelectorAll(".new-faq__answer p").forEach(function (p) {
    var text = p.textContent.replace(/\u00a0/g, "").trim();
    if (text === "") {
      p.remove();
    }
  });

  var items = root.querySelectorAll(".new-faq__item");

  items.forEach(function (item) {
    var btn = item.querySelector(".new-faq__question");

    btn.addEventListener("click", function () {
      var isOpen = item.getAttribute("data-open") === "true";

      // close every other open item first
      items.forEach(function (other) {
        if (other !== item) {
          other.setAttribute("data-open", "false");
          other.querySelector(".new-faq__question").setAttribute("aria-expanded", "false");
        }
      });

      // toggle the clicked one — CSS show/hides the answer via data-open
      item.setAttribute("data-open", isOpen ? "false" : "true");
      btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
    });
  });
};